import * as utils from './saved-filters-utils';
import * as actions from './saved-filters-actions';
import * as selectors from './saved-filters-selectors';
import {reducer} from './saved-filters-reducer';

export const SavedFilters = {reducer, ...actions, ...selectors, utils} as const;
export type {SavedFiltersState} from './saved-filters-reducer';
